import {Component, EventEmitter, inject, OnDestroy, Output} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {DeliveryData} from "../../../../interfaces/delivery";
import {HttpClient} from "@angular/common/http";
import {BaseService} from "../../../../services/base.service";
import {Subject} from "rxjs";

@Component({
  selector: 'app-modal-nalojka-info',
  templateUrl: './modal-nalojka-info.component.html',
  styleUrls: ['./modal-nalojka-info.component.scss']
})
export class ModalNalojkaInfoComponent extends BaseService implements OnDestroy {
  @Output() nalojkaNotAgree: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() nalojkaNotShow: EventEmitter<boolean> = new EventEmitter<boolean>();

  private isDestroyed: Subject<boolean> = new Subject();
  private http: HttpClient = inject(HttpClient);

  public nalojkaMarkup: number;
  public isModalShow: boolean = false;
  public isDarkBackground: boolean = false;

  show() {
    this.http.get(this.apiRoot + 'deliveries/get_deliveries')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: DeliveryData) => {
        this.nalojkaMarkup = data.nalojka_markup;

        this.isModalShow = true;
        this.isDarkBackground = true;
      });
  }

  agree() {
    this.closeModal();
  }

  notAgree() {
    this.closeModal();
    this.nalojkaNotAgree.emit();
  }

  agreeNotShowMore() {
    this.closeModal();
    this.nalojkaNotShow.emit();
  }

  closeModal() {
    this.isModalShow = false
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
